export namespace SettingsAction {
	export class Update {
		static readonly type = '[Settings] Add item'
	}
}
